/* ============================================================
   TRPN — SOLANA SUMMER
   Aucun framework, aucune dependance. Le HTML reste fonctionnel
   sans ce fichier : les formulaires produit sont de vrais <form>
   et les liens de vrais <a>.
   ============================================================ */
(function () {
  "use strict";

  /* ----------------------------------------------------------
     1. Header : passe en fond opaque une fois la page defilee
     ---------------------------------------------------------- */
  function initHeader(root) {
    var onScroll = function () {
      root.classList.toggle("is-stuck", window.scrollY > 24);
    };
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });

    var burger = root.querySelector("[data-trpn-burger]");
    if (burger) {
      burger.addEventListener("click", function () {
        var open = root.hasAttribute("open-menu");
        if (open) {
          root.removeAttribute("open-menu");
        } else {
          root.setAttribute("open-menu", "");
        }
        burger.setAttribute("aria-expanded", String(!open));
      });
    }
  }

  /* ----------------------------------------------------------
     2. Selecteur de variante du hero
     Lit le JSON des variantes, met a jour l'id soumis, le prix,
     la disponibilite et l'image principale.
     ---------------------------------------------------------- */
  function initVariantPicker(form) {
    var dataEl = form.querySelector("[data-trpn-variants]");
    if (!dataEl) return;

    var variants;
    try {
      variants = JSON.parse(dataEl.textContent);
    } catch (e) {
      return;
    }

    var idInput = form.querySelector("[data-trpn-variant-id]");
    var priceEl = form.querySelector("[data-trpn-price]");
    var labelEl = form.querySelector("[data-trpn-atc-label]");
    var submit = form.querySelector("[data-trpn-submit]");
    // On ne remplace l'image du hero par celle de la variante que si le hero
    // affiche deja un visuel produit. Quand un decor est en place (image
    // choisie ou decor grec fourni), il ne doit pas etre ecrase.
    var heroImg = document.querySelector(
      "[data-trpn-hero-image][data-trpn-swap-on-variant]"
    );
    var moneyFormat = form.getAttribute("data-money-format") || "${{amount}}";
    var soldOutText = form.getAttribute("data-sold-out") || "SOLD OUT";
    var addText = form.getAttribute("data-add-text") || "ADD TO CART";

    // Reproduit les formats monetaires Shopify :
    //   {{amount}}                            1,134.65
    //   {{amount_with_comma_separator}}       1.134,65
    //   {{amount_no_decimals}}                1,135
    //   {{amount_with_apostrophe_separator}}  1'134.65
    function group(num, decimals, thousands, decimalSep) {
      var parts = num.toFixed(decimals).split(".");
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
      return parts.length > 1 ? parts.join(decimalSep) : parts[0];
    }

    function formatMoney(cents) {
      var value = cents / 100;
      var match = moneyFormat.match(/\{\{\s*(\w+)\s*\}\}/);
      var placeholder = match ? match[1] : "amount";
      var out;

      switch (placeholder) {
        case "amount_no_decimals":
          out = group(value, 0, ",", ".");
          break;
        case "amount_with_comma_separator":
          out = group(value, 2, ".", ",");
          break;
        case "amount_no_decimals_with_comma_separator":
          out = group(value, 0, ".", ",");
          break;
        case "amount_with_apostrophe_separator":
          out = group(value, 2, "'", ".");
          break;
        default:
          out = group(value, 2, ",", ".");
      }
      return moneyFormat.replace(/\{\{\s*\w+\s*\}\}/, out);
    }

    function selectedOptions() {
      return Array.prototype.map.call(
        form.querySelectorAll("[data-trpn-option]"),
        function (group) {
          var checked = group.querySelector("input:checked");
          return checked ? checked.value : null;
        }
      );
    }

    function matchVariant(selection) {
      for (var i = 0; i < variants.length; i++) {
        var v = variants[i];
        var ok = true;
        for (var j = 0; j < selection.length; j++) {
          if (selection[j] !== null && v.options[j] !== selection[j]) {
            ok = false;
            break;
          }
        }
        if (ok) return v;
      }
      return null;
    }

    function update() {
      var variant = matchVariant(selectedOptions());

      if (!variant) {
        if (submit) {
          submit.disabled = true;
          if (labelEl) labelEl.textContent = soldOutText;
        }
        return;
      }

      if (idInput) idInput.value = variant.id;
      if (priceEl) priceEl.textContent = formatMoney(variant.price);

      if (submit) {
        submit.disabled = !variant.available;
        if (labelEl) labelEl.textContent = variant.available ? addText : soldOutText;
      }

      if (heroImg && variant.image) {
        heroImg.src = variant.image;
        heroImg.removeAttribute("srcset");
      }

      if (window.history && window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set("variant", variant.id);
        window.history.replaceState({}, "", url.toString());
      }
    }

    form.addEventListener("change", function (e) {
      if (e.target.matches("[data-trpn-option] input")) update();
    });

    update();
  }

  /* ----------------------------------------------------------
     3. Galerie du hero : la miniature change l'image de fond
     ---------------------------------------------------------- */
  function initGallery(root) {
    var img = root.querySelector("[data-trpn-hero-image]");
    var thumbs = root.querySelectorAll("[data-trpn-thumb]");
    if (!img || !thumbs.length) return;

    Array.prototype.forEach.call(thumbs, function (thumb) {
      thumb.addEventListener("click", function () {
        var src = thumb.getAttribute("data-full");
        if (!src) return;
        img.src = src;
        img.removeAttribute("srcset");
        Array.prototype.forEach.call(thumbs, function (t) {
          t.classList.toggle("is-active", t === thumb);
        });
      });
    });
  }

  /* ----------------------------------------------------------
     4. Pastilles de coloris des cartes produit
     ---------------------------------------------------------- */
  function initCardSwatches(card) {
    var img = card.querySelector("[data-trpn-card-image]");
    if (!img) return;

    card.addEventListener("change", function (e) {
      var input = e.target;
      if (!input.matches("[data-trpn-swatch]")) return;
      var src = input.getAttribute("data-image");
      if (!src) return;
      img.src = src;
      img.removeAttribute("srcset");
    });
  }

  /* ----------------------------------------------------------
     Amorcage — rejoue apres chaque rechargement de section
     dans l'editeur de theme.
     ---------------------------------------------------------- */
  function boot(scope) {
    var ctx = scope || document;
    ctx.querySelectorAll("[data-trpn-header]").forEach(initHeader);
    ctx.querySelectorAll("[data-trpn-product-form]").forEach(initVariantPicker);
    ctx.querySelectorAll("[data-trpn-hero]").forEach(initGallery);
    ctx.querySelectorAll("[data-trpn-card]").forEach(initCardSwatches);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      boot();
    });
  } else {
    boot();
  }

  document.addEventListener("shopify:section:load", function (e) {
    boot(e.target);
  });
})();
